//Include Both Helper File with needed methods

import {
  
   getTotalReturns,
    
} from "../../../helpers/fakebackend_helper";



import { createAsyncThunk } from "@reduxjs/toolkit";


export const home_total_returnsThunk = createAsyncThunk("home_total_returnsThunk", async ({  token }, { rejectWithValue } ) => {
  try {
    const response = await getTotalReturns( token);
    return response;
  } catch (error) {
    // Properly pass the error structure to the reducer
    return rejectWithValue({
      code: error.data?.code || error.code,
      message: error.message,
      data: error.data
    });
  }
});










